export const loadUnits = [
  {
    value: 'BY_WEIGHT',
    label: 'Tonelada',
    short: 'ton',
  },
  {
    value: 'BY_VOLUME',
    label: 'Volume',
    short: 'lit',
  },
  {
    value: 'BY_UNIT',
    label: 'Unidades',
    short: 'uni',
  },
]
export const loadUnitsMap = {
  BY_WEIGHT: 'toneladas',
  BY_VOLUME: 'volume',
  BY_UNIT: 'unidades',
}

export const historyMap = {
  CREATED: 'Frete criado',
  WAIT_TRANSPORTER_ACCEPT: 'Frete foi ao mercado',
  WAITING_APPROVE: 'Aguardando Aprovação',
  OFFER_COMPLETED: 'Oferta finalizada',
  IN_DELIVERY: 'Entrega iniciada',
  FINISHED: 'Frete concluído',
}

export const paymentTypesMap = {
  BY_WEIGHT: 'Por toneladas',
  BY_VOLUME: 'Por volume',
  BY_UNIT: 'Por unidades',
  CLOSED_VALUE: 'Frete fechado',
}

export const acceptTypes = [
  {
    value: 'FIRST_ACCEPT',
    label: 'Imediato',
  },
  {
    value: 'WAIT_DURATION',
    label: 'Aguardar decisão',
  },
]

export const acceptTypesMap = {
  FIRST_ACCEPT: 'Imediato',
  WAIT_DURATION: 'Aguardar decisão',
}

export const flowTypeMap = {
  INBOUND: 'Inbound',
  OUTBOUND: 'Outbound',
  REVERSE: 'Logística reversa',
}

export const icmsMap = {
  FREE: 'Isento',
  INCLUDED: 'Tributado, incluso no frete',
  NOT_INCLUDED: 'Tributado, não incluso no frete',
}

export const paymentTypes = [
  {
    value: 'CLOSED_VALUE',
    label: 'Frete fechado',
  },
  {
    value: 'BY_UNIT',
    label: 'Por unidade',
  },
  {
    value: 'BY_VOLUME',
    label: 'Por litros',
  },
  {
    value: 'BY_WEIGHT',
    label: 'Por toneladas',
  },
]


export const other = [
  {
    value: 0,
    label: 'Toneladas',
  },
  {
    value: 1,
    label: 'Litros',
  },
]

export const launchScheduleTypes = [
  {
    value: 'immediately',
    label: 'Lançar imediatamente',
  },
  {
    value: 'schedule',
    label: 'Lançamento agendado',
  },
]

export const loadInfoNormal = [
  {
    icon: 'package',
    message: 'O preço do frete é o valor fixo informado.',
    show: true,
    enabled: false,
  },
  {
    icon: 'pound',
    message: 'O preço do frete será calculado por tonelada embarcada.',
    show: true,
    enabled: true,
  },
  {
    icon: 'purposes',
    message: 'Ao aceitar propostas as transportadoras poderão entrar em contato para negociar o frete.',
    show: true,
    enabled: true,
  },
  {
    icon: 'final_purposes',
    message: 'Ao término do período de exposição da carga, caso não haja nenhum aceite, as transportadoras poderão entrar em contato para negociar o frete.',
    show: true,
    enabled: true,
  },
]

export const loadInfoAuction = [
  {
    icon: 'auction',
    message: 'A carga lançada estará disponível para leilão.',
    show: true,
    enabled: true,
  },
  {
    icon: 'bids',
    message: 'As transportadoras darão lances e reduzirão o preço do frete.',
    show: true,
    enabled: true,
  },
  {
    icon: 'package',
    message: 'A carga lançada tem o frete fechado, portanto a transportadora que vencer será responsável por toda a carga.',
    show: true,
    enabled: true,
  },
  {
    icon: 'trophy',
    message: 'A transportadora que detiver o menor lance ao final do leilão transportará a carga.',
    show: true,
    enabled: true,
  },
]

export const loadInfoBatch = [
  {
    icon: 'package',
    message: 'A mínima de retirada é a quantidade mínima que as transportadoras podem dividir sua carga.',
    show: true,
    enabled: false,
  },
  {
    icon: 'pound',
    message: 'O preço do frete será calculado por tonelada embarcada.',
    show: true,
    enabled: true,
  },
  {
    icon: 'final_purposes',
    message: 'Ao término do período de exposição da carga, caso não haja nenhum aceite, as transportadoras poderão entrar em contato para negociar o frete.',
    show: true,
    enabled: true,
  },
]

export const deliveryStatusMap = {
  ASSIGNED_TO_TRANSPORTER: 'Aguardando atribuir motorista',
  WAITING_DRIVER_ACCEPT: 'Aguardando aceite do motorista',
  LINKED_TO_DRIVER_VEHICLE: 'Motorista/veículo vinculado',
  IN_COLLECT: 'Coleta iniciada',
  COLLECT_DONE: 'Coleta finalizada',
  IN_TRANSIT: 'Em trânsito',
  IN_DELIVERY: 'Em processo de entrega',
  DELIVERED: 'Carga entregue',
}

export const statusLabelMap = {
  CREATED: 'Carga criada/Lançamento agendado',
  WAITING_APPROVE: 'Aguardando aprovação',
  WAIT_TRANSPORTER_ACCEPT: 'Aguardando aceite',
  WAITING_APPROVE: 'Aguardando aprovação',
  NEGOTIATION: 'Em negociação',
  OFFER_COMPLETED: 'Oferta finalizada',


  ASSIGNED_TO_TRANSPORTER: 'Aguardando atribuir motorista',
  WAITING_DRIVER_ACCEPT: 'Aguardando aceite do motorista',
  LINKED_TO_DRIVER_VEHICLE: 'Motorista/veículo vinculado',
  IN_COLLECT: 'Coleta iniciada',
  COLLECT_DONE: 'Coleta finalizada',
  IN_TRANSIT: 'Em trânsito',
  // IN_DELIVERY: 'Em processo de entrega',
  IN_DELIVERY: 'Carga atribuída para transportador',
  DELIVERED: 'Carga entregue',


  FINISHED: 'Carga finalizada',
  CANCELED: 'Cancelada',
  EXPIRED: 'Carga expirou',
}

export const searchStatus = [
  { value: 'NEGOTIATION', name: 'Disponível' },
  { value: 'WAIT_BIND_DRIVER', name: 'Atribuir Motorista' },
  { value: 'WAIT_ACCEPT_DRIVER', name: 'Aguardando Motorista' },
  { value: 'BIND_DRIVER', name: 'Motorista Vinculado' },
  { value: 'IN_COLLECT', name: 'Em Coleta' },
  { value: 'IN_TRANSIT', name: 'Em Transito' },
  { value: 'IN_DELIVERY', name: 'Próximo ao cliente' },
  { value: 'WAIT_APPROVE_RECEIPT', name: 'Comprovante Pendente de aprovação' },
  { value: 'REFUSED_RECEIPT', name: 'Comprovante Recusado' },
  { value: 'APPROVED_RECEIPT', name: 'Comprovante Aprovado' },
]

export const scheduledStatus = {
  CREATED: 'Carga criada/Lançamento agendado',
}

export const negotiationStatus = {
  WAIT_TRANSPORTER_ACCEPT: 'Aguardando aceite',
  WAITING_APPROVE: 'Aguardando aprovação',
  NEGOTIATION: 'Em negociação',
  OFFER_COMPLETED: 'Oferta finalizada',
}

export const onGoingStatus = {
  ASSIGNED_TO_TRANSPORTER: 'Aguardando atribuir motorista',
  LINKED_TO_DRIVER_VEHICLE: 'Motorista/veículo vinculado',
  IN_COLLECT: 'Coleta iniciada',
  COLLECT_DONE: 'Coleta finalizada',
  IN_TRANSIT: 'Em trânsito',
  IN_DELIVERY: 'Em processo de entrega',
}

export const reviewStatus = {
  DELIVERED: 'Carga entregue',
}

export const closedStatus = {
  FINISHED: 'Carga finalizada',
  CANCELED: 'Cancelada',
  EXPIRED: 'Carga expirou',
}

export const incidentStatusMap = {
  CREATED: 'Aberto',
  CANCELED: 'Cancelado',
  RESOLVED: 'Fechado',
}

export const incidentCategories = {
  OTHER: 'Outros...',
  FISCAL: 'Ocorrência fiscal',
  TRANSPORT: 'Ocorrência no transporte',
  MERCHANDISE: 'Ocorrência da mercadoria',
  COMMERCIAL: 'Ocorrência comercial',
  CLIENT: 'Ocorrência com o cliente',
}

export const incidentCategoriesMap = {
  OTHER: 'Outros',
  FISCAL: 'Fiscal',
  TRANSPORT: 'Transporte',
  MERCHANDISE: 'Mercadoria',
  COMMERCIAL: 'Comercial',
  CLIENT: 'Cliente',
}

export const incidentSeverity = {
  LOW: 'Baixo',
  MEDIUM: 'Médio',
  HIGH: 'Alto',
}

export const agentMap = {
  DRIVER: 'Motorista',
  SHIPPER: 'Embarcador',
  TRANSPORTER: 'Transportadora',
}

// export const loadPagination = 5

export const incompleteMsg = 'Não informado'

export const loadPagination = 8
export const eventsPagination = 20

export const shippersPagination = 10

export const driversPagination = 10

export const invitesPagination = 10

export const notificationsPagination = 10

export const fleetPagination = 20

export const incidentsPagination = 10

export const loasHistoryPagination = 20
